import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ActionButton, FormDialog, InputField } from "../v3";
import { updateQuantityValidationRules } from "../../pages/tools/validations";
import { toast } from "react-toastify";
import { ToolService } from "../../services";
import { useParams } from "react-router-dom";

export const UpdateQuantity = ({
  open = false,
  operationType = "increment",
  selectedInventory = {},
  onClose = () => {},
  onSuccess = () => {},
}) => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [storeName, setStoreName] = useState("");
  const [stockDetails, setStockDetails] = useState({ storeId: undefined, quantity: undefined, description: undefined });

  const { id } = useParams();

  useEffect(() => {
    if (selectedInventory) {
      setStockDetails({ storeId: selectedInventory?.storeId });
      setStoreName(selectedInventory?.storeName);
    }
  }, [selectedInventory]);

  const updateDetailsState = (event) => {
    const { name, value } = event.target;
    setStockDetails((prev) => ({ ...prev, [name]: value }));
    if (name === "quantity") {
      const num = parseFloat(value);

      if (value !== "" && (isNaN(num) || num <= 0))
        setErrors((prev) => ({ ...prev, quantity: "Quantity must be greater than 0" }));
      else if (value !== "" && !Number.isInteger(num))
        setErrors((prev) => ({ ...prev, quantity: "Decimal values are not allowed" }));
      else if (value !== "" && num > selectedInventory?.count && operationType === "decrement")
        setErrors((prev) => ({ ...prev, quantity: `Cannot exceed (${selectedInventory?.count}) quantities` }));
      else
        setErrors((prev) => {
          const { quantity, ...rest } = prev;
          return rest;
        });
    }
  };

  const handleClearForm = () => {
    setStockDetails({
      storeId: undefined,
      quantity: undefined,
      description: undefined,
    });
  };

  const handleCloseModal = () => {
    handleClearForm();
    setErrors({});
    onClose();
  };

  const handleUpdateStock = async () => {
    setErrors({});

    const validationErrors = updateQuantityValidationRules(stockDetails);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // validate quantity
    const remainingQuantity = selectedInventory?.count;
    if (stockDetails.quantity > remainingQuantity && operationType === "decrement") {
      setErrors((prev) => ({ ...prev, quantity: `Cannot exceed (${remainingQuantity}) quantities` }));
      return;
    }

    if (stockDetails.quantity) stockDetails.quantity = Number(stockDetails.quantity);
    const payload = { ...stockDetails, quantity: Number(stockDetails.quantity) };

    try {
      setLoading(true);
      if (operationType === "increment") await ToolService.incrementQuantity(id, payload);
      else await ToolService.decrementQuantity(id, payload);
      toast.success("Quantity updated successfully.");
      handleCloseModal();
      onSuccess?.();
    } catch (error) {
      toast.error("Error updating quantity.");
      console.error("Error updating quantity:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <FormDialog
      open={open}
      title={`${operationType === "increment" ? "Increment" : "Decrement"} Quantity`}
      actions={
        <>
          <ActionButton buttonText="Cancel" onButtonClick={handleCloseModal} variant="outlined" />
          <ActionButton buttonText="Save" onButtonClick={handleUpdateStock} disabled={loading} />
        </>
      }
    >
      <Box mt={1}>
        <Box display="flex" gap={2} sx={{ width: 500 }}>
          <InputField
            required
            disabled={true}
            label="Project / Warehouse"
            name="storeId"
            value={storeName}
            onChange={updateDetailsState}
            error={!!errors.storeId}
            helperText={errors.storeId}
            fullWidth
          />
          <InputField
            required
            type="number"
            label="Quantity"
            name="quantity"
            value={stockDetails.quantity}
            onChange={updateDetailsState}
            error={!!errors.quantity}
            helperText={errors.quantity}
            fullWidth
          />
        </Box>
        <Box display="flex" gap={2}>
          <InputField
            label="Description"
            name="description"
            value={stockDetails.description}
            onChange={updateDetailsState}
            error={!!errors.description}
            helperText={errors.description}
            fullWidth
          />
        </Box>
      </Box>
    </FormDialog>
  );
};
